
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "./developer/mixins";

@Component
export default class SuspendedPresentableMixin extends Mixins(DeveloperPresentableMixin) {
  @Prop()
  url: string;

  @Prop()
  title: string;

  @Prop()
  message: string;

  @Prop({ default: 0 })
  timeoutAsMsec: number;

  data() {
    return {
      timer: null as NodeJS.Timeout,
    };
  }
  timer: NodeJS.Timeout; // DocuMaker3ではNodeJS版使うで統一されてるようなので合わせる.

  get shouldCloseAutomatically(): boolean {
    return !!this.timer;
  }

  get timeoutAsSec(): number {
    return this.timeoutAsMsec / 1000;
  }

  created() {
    if (!!this.timeoutAsMsec && (0 < this.timeoutAsMsec)) {
      this.createTimer();
    }
  }

  private createTimer(): void {
    this.$logger.debug("画面クローズタイマーを設定します.(" + this.timeoutAsMsec + "ms)");
    this.timer = setTimeout(() => {
      this.$logger.debug("画面クローズタイマー満了によってクローズします.(" + this.timeoutAsMsec + "ms)");
      this.timer = null;
      this.$closeWindow();
    }, this.timeoutAsMsec);
  }

  private cancelTimer(): void {
    if (!!this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  close(): void {
    this.$logger.debug("画面クローズ操作によってクローズします.");
    this.cancelTimer();
    this.$closeWindow();
  }

  destroyed() {
    this.cancelTimer();
  }
}
